<div class="project-bulk-container">

  <div *ngIf="isShowChaseControls">
      <form [formGroup]="formGroup">
        <div class="p-grid p-fluid" *ngIf="isShowStatusType">
          <div class="p-col-3 p-md-3 p-lg-3">
            <span class="error-icon"><app-icon class="error-icon" iconName="question-circle" *ngIf="isShowStatusError" [title]="required"></app-icon></span>
            <form-factory [formGroup]="form" [model]="statusInput" (onChange)="onSelectedStatus($event)"></form-factory>
          </div>
        </div>

        <div *ngIf="isShowPendCode">
          <div class="p-grid p-fluid">
            <div class="p-col-3 p-md-3 p-lg-3">
              <form-factory [formGroup]="formGroup" [model]="pendCodesInput" (onChange)="setPendCodeInvoiceControls()"></form-factory>
            </div>
          </div>

          <div class="p-grid p-fluid" *ngIf="isPendReasonVisible">
            <div class="p-col-3 p-md-3 p-lg-3">
              <form-factory [formGroup]="formGroup" [model]="pendReasonInput" ></form-factory>
            </div>
          </div>

          
          <div class="p-grid p-fluid" *ngIf="isShowPendCodeServerity">
            <div class="p-col-3 p-md-3 p-lg-3">
              <form-factory [formGroup]="formGroup" [model]="pendSeverityInput" > </form-factory>
            </div>
          </div>

          <div class="p-grid p-fluid">
            <div class="p-col-3 p-md-3 p-lg-3">
              <form-factory [formGroup]="formGroup" [model]="invoiceNumberInput"></form-factory>
            </div>
          </div>

          <div class="p-grid p-fluid">
            <div class="p-col-3 p-md-3 p-lg-3">
              <form-factory [formGroup]="formGroup" [model]="invoiceAmountInput"></form-factory>
            </div>
          </div>

          <div class="p-grid p-fluid">
            <div class="p-col-3 p-md-3 p-lg-3">
              <form-factory [formGroup]="formGroup" [model]="pendCompanyInput"></form-factory>
            </div>
          </div>
        </div>

        <div class="p-grid p-fluid" *ngIf="isShowAssignUser">
          <div class="p-col-3 p-md-3 p-lg-3">
            <span class="error-icon"><app-icon class="error-icon" iconName="question-circle" *ngIf="isShowAssignUsers" [title]="required"></app-icon></span>
            <form-factory [formGroup]="form" [model]="userInput" (onChange)="onSelectedUsers($event)"></form-factory>
          </div>
        </div>

        <div class="p-grid p-fluid" *ngIf="isShowSelectRetriever">
          <div class="p-col-3 p-md-3 p-lg-3">
            <span class="error-icon"><app-icon class="error-icon" iconName="question-circle" *ngIf="isShowRetrieverError" [title]="required"></app-icon></span>
            <form-factory [formGroup]="form" [model]="retrieverInput" (onChange)="onSelectRetriever($event)"></form-factory>
          </div>
        </div>

        <div class="p-grid p-fluid">
          <div class="p-col-6 p-md-6 p-lg-6">
            <form-factory [formGroup]="formGroup" [model]="chasesNotes"></form-factory>
          </div>
        </div>

        <div class="p-grid p-fluid">
          <div class="p-col-12 p-md-12 p-lg-12">
            <app-button text="CONTINUE TO VALIDATION" (onClick)="validate()"></app-button>
          </div>
        </div>

      </form>
  </div>

  <div class="p-grid p-fluid" *ngIf="isShowValidateGrid && !isDurableJobQueued">
    <div class="p-col-12 p-md-12 p-lg-12">
      <app-basic-grid [configuration]="serverGridConfiguration"
                       [data]="data">
      </app-basic-grid>
    </div>
    <div class="p-grid p-fluid finish-bulk-update-container">
      <div class="p-col-12 p-md-12 p-lg-12">
        <app-button (onClick)="finalBulkUpdate()" text="FINISH BULK UPDATE" [disabled]="isFinalBulkUpdate"></app-button>
      </div>
    </div>
  </div>

  <div class="bulk-update-chase__notice" *ngIf="isDurableJobQueued">
    <app-icon iconName="info-circle" class="bulk-update-chase__notice-icon"></app-icon>
    <div>
      <div class="bulk-update-chase__notice-title bold">Bulk action submitted</div>
      <div>
        This bulk change involves a large number of chases, so it's being validated in the
        background. You'll receive a notification when validation finishes &mdash; open it to
        review the results and continue.
      </div>
    </div>
  </div>
</div>
